export const encyclopediaDe = {
  // Gemeinsam
  'encyclopedia.lockAria': 'Versiegelt — entsperren zum Lesen',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'Die Enzyklopädie',
  'encyclopedia.page.seoDescription':
    'Durchsuche das lebende Grimoire von Grymwyrd — Monster, Zauber, Spezies, Gegenstände, Orte und mehr.',
  'encyclopedia.page.heading': 'Die Enzyklopädie',
  'encyclopedia.page.subtitle': 'Das lebende Grimoire jedes Schreckens, jedes Zaubers und jeder Legende in Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': '{plural} durchsuchen…',
  'encyclopedia.page.searchAria': '{plural} durchsuchen',
  'encyclopedia.page.clearSearch': 'Suche zurücksetzen',
  'encyclopedia.page.systemNotLivePrefix': 'Der Schleier hat sich noch nicht geteilt für',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Kein an diesen Ritus gebundenes Wissen ist durchgedrungen — sein Grimoire wartet jenseits der Finsternis.',
  'encyclopedia.page.returnToAllSystems': 'Zurück zu allen Systemen',
  'encyclopedia.page.settingNotLivePrefix': 'Die Lande von',
  'encyclopedia.page.settingNotLiveSuffix':
    ' werden noch kartografiert — ihre Einträge sind noch nicht an die Welt gebunden. Bis die Kartografen fertig sind, antwortet hier nichts.',
  'encyclopedia.page.returnToAllRealms': 'Zurück zu allen Reichen',
  'encyclopedia.page.filteringBy': 'Gefiltert nach',
  'encyclopedia.page.filterSystem': 'System „{label}“',
  'encyclopedia.page.filterCanon': 'Kanon-Ebene „{label}“',
  'encyclopedia.page.filterSetting': 'Welt „{label}“',
  'encyclopedia.page.canonNote': 'Die Kanon-Ebene gilt, sobald Entitäten in der API markiert sind (siehe _docs/13). ',
  'encyclopedia.page.clear': 'Zurücksetzen',
  'encyclopedia.page.hide': 'Ausblenden',
  'encyclopedia.page.filter': 'Filtern',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': '{name} entsperren (Grymwyrd-Inhalt)',
  'encyclopedia.entityCard.viewAria': 'Eintrag zu {name} ansehen',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Seitennavigation ({position})',
  'encyclopedia.grid.prev': 'Zurück',
  'encyclopedia.grid.next': 'Weiter',
  'encyclopedia.grid.pageOf': 'Seite {page} von {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} Ergebnisse',
  'encyclopedia.grid.scrying': 'Durchforste die Archive…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Absteigend sortieren',
  'encyclopedia.grid.sortAscAria': 'Aufsteigend sortieren',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Ansichtsmodus',
  'encyclopedia.grid.gridViewAria': 'Rasteransicht',
  'encyclopedia.grid.listViewAria': 'Listenansicht',
  'encyclopedia.grid.jumpToLetterAria': 'Zu Buchstabe springen',
  'encyclopedia.grid.all': 'Alle',
  'encyclopedia.grid.letterSymbolAria': 'Einträge, die mit einer Zahl oder einem Symbol beginnen',
  'encyclopedia.grid.letterAria': 'Einträge, die mit {letter} beginnen',
  'encyclopedia.grid.emptyTitle': 'Das Archiv schweigt',
  'encyclopedia.grid.emptyForLetter': 'Keine {plural} tragen einen Namen, der mit „{letter}“ beginnt.',
  'encyclopedia.grid.emptyAll': 'Keine {plural} folgen deinem Ruf.',
  'encyclopedia.grid.turningPages': 'Blättere die Seiten um…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (keine Abbildung)',
  'encyclopedia.entityImage.noVision': 'Keine Vision',

  // FacetSidebar
  'encyclopedia.facets.all': 'Alle',
  'encyclopedia.facets.soon': 'Bald',
  'encyclopedia.facets.navAria': 'Filter nach Entitätstyp',
  'encyclopedia.facets.clearAll': 'Alle Filter zurücksetzen',
  'encyclopedia.facets.lorebook': 'Lorebook',
  'encyclopedia.facets.gameSystem': 'Spielsystem',
  'encyclopedia.facets.canonLayer': 'Kanon-Ebene',
  'encyclopedia.facets.setting': 'Welt',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Durchsuche den Schleier',
  'encyclopedia.globalSearch.placeholder': 'Suche nach Monstern, Zaubern, Orten, Wissen…',
  'encyclopedia.globalSearch.queryAria': 'Suchanfrage',
  'encyclopedia.globalSearch.loading': 'Durchforste…',
  'encyclopedia.globalSearch.empty': 'Nichts regt sich in der Finsternis bei „{q}“.',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Grymwyrd-Inhalt — entsperren zum Lesen',
  'encyclopedia.lockBadge.label': 'Versiegelt',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Versiegelter Inhalt',
  'encyclopedia.lockedGate.defaultTitle': 'Dieses Wissen ist versiegelt',
  'encyclopedia.lockedGate.body':
    'Grymwyrds eigenes Bestiarium, seine Zauber und Legenden sind an den Grymwyrd-Kataklysmus gebunden. Der offene SRD-Kanon bleibt frei — doch um das ewige Zwielicht selbst zu durchwandern, ergreife das Buch.',
  'encyclopedia.lockedGate.unlockCta': 'Grymwyrd entsperren',
  'encyclopedia.lockedGate.signInCta': 'Bereits Unterstützer? Anmelden',
  'encyclopedia.lockedGate.backerNote':
    'Unterstützer, die für Grymwyrd gespendet haben, besitzen dies bereits — melde dich an, um es in deinem Konto freizuschalten.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — {total} gewürfelt',
  'encyclopedia.table.noRowMatched': 'Keine Zeile passte zu {total}.',
  'encyclopedia.table.loading': 'Entfalte die Tabelle…',
  'encyclopedia.table.error': 'Diese Tabelle konnte nicht gezeichnet werden.',
  'encyclopedia.table.roll': '{formula} würfeln',
  'encyclopedia.table.lastRoll': 'Letzter Wurf: {value}',
  'encyclopedia.table.noMatchingRow': ' · keine passende Zeile',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Eintrag',
  'encyclopedia.detail.addedToCampaign': 'Zu deiner Kampagne hinzugefügt.',
  'encyclopedia.detail.addError': 'Das Kampagnen-Gewölbe war nicht erreichbar. Versuche es später erneut.',
  'encyclopedia.detail.unknownType': 'Unbekannter Eintragstyp.',
  'encyclopedia.detail.seoDescription': '{name} — ein {label} in der Grymwyrd-Enzyklopädie.',
  'encyclopedia.detail.breadcrumbAria': 'Navigationspfad',
  'encyclopedia.detail.breadcrumbRoot': 'Enzyklopädie',
  'encyclopedia.detail.sourceVersionAria': 'Quellversion',
  'encyclopedia.detail.versionConsolidated': 'Konsolidiert',
  'encyclopedia.detail.versionBook': 'Bestimmtes Buch',
  'encyclopedia.detail.removeBookmarkAria': 'Lesezeichen entfernen',
  'encyclopedia.detail.addBookmarkAria': 'Lesezeichen hinzufügen',
  'encyclopedia.detail.bookmarked': 'Mit Lesezeichen',
  'encyclopedia.detail.bookmark': 'Lesezeichen',
  'encyclopedia.detail.addToCampaign': 'Zur Kampagne hinzufügen',
  'encyclopedia.detail.sealedTitle': '{name} ist versiegelt',
  'encyclopedia.detail.bookVariantNote':
    'Es wird der konsolidierte Eintrag angezeigt; buchspezifischer Variantentext erscheint hier, sobald die Buchausgaben verknüpft sind.',
  'encyclopedia.detail.tablistAria': 'Eintragsabschnitte',
  'encyclopedia.detail.tab.lore': 'Wissen',
  'encyclopedia.detail.tab.stats': 'Werte',
  'encyclopedia.detail.tab.gallery': 'Galerie',
  'encyclopedia.detail.tab.relations': 'Beziehungen',
  'encyclopedia.detail.tab.discussions': 'Diskussionen',
  'encyclopedia.detail.tab.claims': 'Spieleransprüche',
  'encyclopedia.detail.loading': 'Erwecke den Eintrag…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Grabe das Wissen aus…',
  'encyclopedia.lore.empty': 'Die Geschichte dieses Eintrags bleibt ungeschrieben.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Lese die Runen…',
  'encyclopedia.stats.empty': 'Für diesen Eintrag sind keine Spielwerte verzeichnet.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Entwickle die Visionen…',
  'encyclopedia.gallery.emptyTitle': 'Noch keine Visionen',
  'encyclopedia.gallery.emptyBody': 'An diesen Eintrag wurde noch keine Abbildung gebunden. Steuere eine im Gewölbe bei.',
  'encyclopedia.gallery.artworkAlt': 'Abbildung der Entität',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Sammle das Flüstern…',
  'encyclopedia.discussions.emptyTitle': 'Stille in den Hallen',
  'encyclopedia.discussions.emptyBody': 'Sei der Erste, der diesen Eintrag mit anderen Wanderern bespricht.',
  'encyclopedia.discussions.startCta': 'Eine Diskussion beginnen',
  'encyclopedia.discussions.untitledThread': 'Unbenannter Thread',
  'encyclopedia.discussions.byAuthor': 'von {author}',
  'encyclopedia.discussions.replyCount': '{count} Antworten',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Dein Anspruch wurde zur Prüfung vermerkt.',
  'encyclopedia.claims.recordError': 'Die Schreiber konnten deinen Anspruch nicht vermerken. Versuche es später erneut.',
  'encyclopedia.claims.loading': 'Befrage den Kanon…',
  'encyclopedia.claims.emptyTitle': 'Noch keine Spieleransprüche',
  'encyclopedia.claims.emptyBody': 'Noch kein Wanderer hat seine Legende in diesen Eintrag eingewoben.',
  'encyclopedia.claims.claimCta': 'Dies beanspruchen',
  'encyclopedia.claims.signInCta': 'Anmelden, um Anspruch zu erheben',
  'encyclopedia.claims.untitledClaim': 'Unbenannter Anspruch',
  'encyclopedia.claims.byAuthor': 'von {author}',
  'encyclopedia.claims.addCta': 'Deinen Anspruch hinzufügen',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Dieser Eintrag',
  'encyclopedia.relations.relationLabel': 'Beziehung {index}',
  'encyclopedia.relations.kindredLabel': 'Verwandter {index}',
  'encyclopedia.relations.loading': 'Verfolge die Fäden des Schicksals…',
  'encyclopedia.relations.hintIntro': 'Klicke auf einen Knoten, um zu jenem Eintrag zu gelangen. Die gezeigten Fäden sind',
  'encyclopedia.relations.hintCanonical': ' kanonische Beziehungen.',
  'encyclopedia.relations.hintKindred': ' Verwandte desselben Typs.',
}
